import ApiService from './ApiService';

export default class BookingApi extends ApiService {
    getBikeBookingDetail(payload) {
        const { id, ...rest } = payload;
        return this.get(`customer/booking-bikes/${id}`, rest);
    }

    getAllBikeInLocation(payload) {
        const { id, ...rest } = payload;
        return this.get(`customer/bikes/locations/${id}`, rest);
    }

    getBookingOption() {
        return this.get('customer/booking-bikes/option');
    }

    postCheckingBookingData(payload) {
        return this.post('customer/booking-bikes/calculate-cost', payload);
    }

    postPayment(payload) {
        return this.post('customer/booking-bikes/order', payload);
    }

    getCouponOneTimeInfo(code) {
        return this.get(`customer/booking-bikes/coupon/${code}`);
    }

    getStatusPayment(id) {
        return this.get(`customer/orders/payment-info/${id}`);
    }

    // #region Return bike
    getBeforeBikeReturn(id) {
        return this.get(`customer/orders/before-return-bike/${id}`);
    }

    getBikeReturn(id) {
        return this.get(`customer/orders/return-bike/${id}`);
    }

    postBikeReturn(payload) {
        const { id, ...rest } = payload;
        return this.post(`customer/orders/return-bike/${id}`, rest);
    }
    // #endregion Return bike

    getCouponForeverOfUser() {
        return this.get('customer/coupon-forever');
    }
}
